import React from 'react';

/**
 *  with this lazy import generic components will remain generic
 */
export function lazy<T>(factory: () => Promise<{ default: T }>) {
	return React.lazy(factory as any) as T;
}
